import childrenArray from '../childrenArray';
/**
 * Returns children of given type.
 *
 * @param children Component children.
 * @param propHandler Function to handle prop modification.
 * @param exclude Inverts functionality and filters out the given type.
 */
export const childrenOfType = (children, type, exclude = false) =>
  childrenArray(children, exclude).filter(child =>
    exclude ? child.type !== type : child.type === type
  );
export default childrenOfType;
